import { render, staticRenderFns } from "./SyncTypeCard.vue?vue&type=template&id=ba5c78f4&scoped=true&"
import script from "./SyncTypeCard.vue?vue&type=script&lang=ts&"
export * from "./SyncTypeCard.vue?vue&type=script&lang=ts&"
import style0 from "./SyncTypeCard.vue?vue&type=style&index=0&id=ba5c78f4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba5c78f4",
  null
  
)

export default component.exports